import { render, staticRenderFns } from "./combination.vue?vue&type=template&id=8def9116&scoped=true"
import script from "./combination.vue?vue&type=script&lang=js"
export * from "./combination.vue?vue&type=script&lang=js"
import style0 from "./combination.vue?vue&type=style&index=0&id=8def9116&prod&lang=scss&scoped=true"
import style1 from "./combination.vue?vue&type=style&index=1&id=8def9116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8def9116",
  null
  
)

export default component.exports